/**
 * Bumped whenever a conformance rule is added or tightened. A verdict's key
 * (`sha256(artifactType, artifactId, catalogVersion, resolutionHash, CONFORMANCE_RULESET_VERSION)`)
 * changes the instant this changes, which marks every stored verdict `stale` — the "re-verify
 * everything" trigger for a release that tightens what `verifyArtifact` checks.
 */
export const CONFORMANCE_RULESET_VERSION = 1;
